import { createFetchThunk } from "../common/commonFetchThunk.js";
import { getSubServiceApi } from "../../api/subServiceApi/subService.api";
export const fetchSubServices = createFetchThunk({
  typePrefix: "subServices/fetch",
  apiFn: getSubServiceApi,
  errorMessage: "Failed to fetch Sub Services",
});
